import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';
import { cioanalytics } from '@/main';

import store from "../../store"

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function access(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/products/access`, params, options)
    .then((res) => {
      return res.data;
    });
}

function checkAccess(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/products/checkAccess`, params, options)
    .then((res) => {
      return res.data;
    });
}

function checkAccessByType(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/products/checkAccessByType`, params, options)
    .then((res) => {
      return res.data;
    });
}

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/user/cart/view`, options).then((res) => {
    const count = res?.data?.itemCount || 0;
    const items = res?.data?.items || [];
    if(count > 0 && items.length > 0) {
      const itemList = items.map(item => ({
        sku: item.id, // Laravel: 'id' => $item->item_id
        name: item.name,
        type: item.type,
        details: item.details,
        fullDetails: item.fullDetails,
        area: item.area,
        price: parseFloat(item.price) || 0,
        qty: 1
      }));

      const id = res?.data?.cartID || null;
      if(id !== null) {
        cioanalytics.track('cart', {
          cart_id: id,
          items: itemList,
          total: res?.data?.total,
          currency: 'USD',
          updated_at: new Date().toISOString()
        });
      }
    } else {
      /*if (!store.getters["user/user_type"].retail === true && res?.data?.cartID) {
        cioanalytics.track('cart', {
          cart_id: res?.data?.cartID,
          items: [],
          total: res?.data?.total,
          currency: 'USD',
          updated_at: new Date().toISOString()
        });
      }*/
    }

    
    return res;
  });
}

function remove(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/cart/remove`, params, options)
    .then((res) => {
      return res.data;
    });
}

export default {
  checkAccess,
  checkAccessByType,
  access,
  list,
  remove
};
